import * as yup from 'yup'
import { SelectOption } from '../../../../../components'
import { REQEXP_ONLY_NUMBERS } from '../../../../../constants'
import {
  getSelectOptionDisplayValue,
  getValidationRegExp,
  stringContainsNbrOfNumbers,
  validateDateType,
  validateNullableString,
  validateRequiredString,
  validateRequiredStringMatch,
  validateStringMaxLength
} from '../../../../../utils'
import { isAddressLocationDomestic, isAddressTemporaryType } from '../utils'

export const validateAddressDate = () =>
  validateDateType()
    .test(
      'test-address-date',
      'common.commonErrors.required',
      function (value) {
        const isDateNullForTempAddress =
          !value && isAddressTemporaryType(this.parent.tyyppi)
        return !isDateNullForTempAddress
      }
    )
    .nullable()

export const validateName = (
  maxLength: number,
  requiredTranslationId: string
) =>
  validateStringMaxLength(maxLength)
    .matches(
      getValidationRegExp('isPersonName'),
      'common.commonErrors.invalidCharacters'
    )
    .required(requiredTranslationId)

export const getValidationSchema = (postalCodeOptions: SelectOption[]) =>
  yup.object().shape({
    yhteystiedot: yup.object().shape({
      osoitteet: yup.array().of(
        yup.object().shape({
          maaKoodi: validateRequiredString(),
          postinumero: validateRequiredStringMatch(
            REQEXP_ONLY_NUMBERS,
            'common.commonErrors.invalidCharacters'
          ).test(
            'test-address-postalcode-invalid',
            'pages.ownInfoPage.baseDetails.addresses.postalCode.error.invalid',
            function (value) {
              const isInvalidForDomesticAddress =
                value &&
                isAddressLocationDomestic(this.parent.maaKoodi) &&
                (!stringContainsNbrOfNumbers(value, 5) ||
                  getSelectOptionDisplayValue(postalCodeOptions, value) === '')
              return !isInvalidForDomesticAddress
            }
          ),
          postitoimipaikka: validateRequiredString(),
          katuosoite: validateRequiredString(),
          tyyppi: validateRequiredString(),
          voimaantulopvm: validateAddressDate(),
          paattymispvm: validateAddressDate()
        })
      ),
      sahkopostit: yup.array().of(
        yup.object().shape({
          sahkopostiosoite: validateRequiredString().email(
            'pages.ownInfoPage.baseDetails.emailAddresses.error.invalidCharacters'
          )
        })
      ),
      puhelinnumerot: yup.array().of(
        yup.object().shape({
          puhelinnumero: validateRequiredStringMatch(
            getValidationRegExp('isPhoneNumberValue'),
            'pages.ownInfoPage.baseDetails.phoneNumbers.error.invalidCharacters'
          ).max(25, 'common.commonErrors.tooLong')
        })
      )
    }),
    businessLanguage: yup.string(),
    nimi: yup.object().shape({
      sukunimi: validateName(
        40,
        'pages.ownInfoPage.baseDetails.personalInformation.lastName.error.required'
      ),
      etunimet: validateName(
        30,
        'pages.ownInfoPage.baseDetails.personalInformation.firstNames.error.required'
      ),
      kutsumanimi: validateName(
        20,
        'pages.ownInfoPage.baseDetails.personalInformation.callingName.error.required'
      )
    }),
    jasennumero: yup.number(),
    kansalaisuus: yup.object().shape({
      kansalaisuusKoodi: validateNullableString()
    }),
    aidinkieli: yup.object().shape({
      aidinkieliKoodi: validateNullableString()
    })
  })
